import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    super('dishes', {
      detail: {
        dish: null,
        loading: false,
        error: null,
      },
    });

    this.setupEvents();
  }

  setupEvents() {
    // ============ DETAIL EVENTS ============
    this.on(constants.EVENTS.DISH.DISH_DETAIL_LOADING, () => {
      this.state.detail.loading = true;
      this.state.detail.error = null;
    });

    this.on(constants.EVENTS.DISH.DISH_DETAIL_LOADED, (dish) => {
      this.state.detail.dish = dish;
      this.state.detail.loading = false;
      this.state.detail.error = null;
    });

    this.on(constants.EVENTS.DISH.DISH_DETAIL_ERROR, (error) => {
      this.state.detail.loading = false;
      this.state.detail.error = error?.message || error;
      this.state.detail.dish = null;
    });
  }

  // Getters
  get dishDetail() {
    return this.state.detail.dish;
  }

  get isLoading() {
    return this.state.detail.loading;
  }

  get hasError() {
    return !!this.state.detail.error;
  }

  get error() {
    return this.state.detail.error;
  }
}

export default Store;
